import React from 'react';

import {MainLayout} from 'widgets/layout';
import {listPageClassName} from 'shared/ui/ListPage/ListPage';
import {DomainIncidentsScreen} from 'features/domain';

const DomainIncidentsPage: React.FC = () => {
    return (
        <MainLayout className={listPageClassName}>
            <DomainIncidentsScreen />
        </MainLayout>
    );
};

export default DomainIncidentsPage;
